import { render, staticRenderFns } from "./currentExhibition.vue?vue&type=template&id=7e50c8fe&scoped=true"
import script from "./currentExhibition.vue?vue&type=script&lang=js"
export * from "./currentExhibition.vue?vue&type=script&lang=js"
import style0 from "./currentExhibition.vue?vue&type=style&index=0&id=7e50c8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50c8fe",
  null
  
)

export default component.exports